// extracted by mini-css-extract-plugin
module.exports = {"blogBox":"myBlogs_blogBox__3IMeI","tags":"myBlogs_tags__3Q2fr"};